<app-breadcrumbs>x</app-breadcrumbs>

<div class="contact-us flex flex-wrap justify-center items-center gap-5  bg-gray-200 ">
  <div *ngIf="!showSuccessBox">

    <form [formGroup]="contactUsForm" (ngSubmit)="submitContactUs()"
      class="w-full max-w-lg bg-white rounded-lg shadow-md my-5 p-6">
      <p class="py-5 font-bold">We’d love to hear from you! Whether you have a question about our products, need support, or just
        want to connect—our team is ready to help. </p>
      <div class="flex flex-wrap -mx-3 mb-6">
        <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0">
          <label class="block uppercase tracking-wide text-black text-xs font-bold mb-2" for="name">
            Name
          </label>
          <input formControlName="full_name"
            class="appearance-none block w-full bg-gray-200 text-black border rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
            id="name" type="text" placeholder="name">
          <span class="text-sm text-red-500"
            *ngIf="contactUsForm.get('full_name')?.dirty && contactUsForm.get('full_name')?.errors">Invalid Name</span>
        </div>
        <div class="w-full md:w-1/2 px-3">
          <label class="block uppercase tracking-wide text-black text-xs font-bold mb-2" for="email">
            Email
          </label>
          <input formControlName="email"
            class="appearance-none block w-full bg-gray-200 text-black border rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
            id="email" type="email" placeholder="email@example.com">
          <span class="text-sm text-red-500"
            *ngIf="contactUsForm.get('email')?.dirty && contactUsForm.get('email')?.errors">Invalid Email</span>
        </div>
      </div>
      <div class="flex flex-wrap -mx-3 mb-2">
        <div class="w-full px-3">
          <label class="block uppercase tracking-wide text-black text-xs font-bold mb-2" for="phone">
            Phone
          </label>
          <input formControlName="phone"
            class="appearance-none block w-full bg-gray-200 text-black border rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
            id="phone" type="text" placeholder="(91) 9999999999">
          <span class="text-sm text-red-500"
            *ngIf="contactUsForm.get('phone')?.dirty && contactUsForm.get('phone')?.errors">Invalid Phone</span>
        </div>
      </div>
      <div class="flex flex-wrap -mx-3 mb-2">
        <div class="w-full px-3">
          <label class="block uppercase tracking-wide text-black text-xs font-bold mb-2" for="query">
            Query
          </label>
          <textarea formControlName="message"
            class=" no-resize appearance-none block w-full bg-gray-200 text-black border rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white h-24 resize-none"
            id="query"></textarea>
          <span class="text-sm text-red-500"
            *ngIf="contactUsForm.get('message')?.dirty && contactUsForm.get('message')?.errors">Invalid Message</span>
        </div>
      </div>
      <div class="md:flex md:items-center">
        <div class="md:w-1/3">
          <button [disabled]="contactUsForm.invalid"
            class="shadow bg-secondary hover:bg-primary-dark focus:shadow-outline focus:outline-none text-white font-bold py-2 px-4 rounded"
            type="submit">
            Send
          </button>
        </div>
        <div class="md:w-2/3"></div>
      </div>
    </form>

  </div>

  <div *ngIf="showSuccessBox" class="query-noted text-black bg-white p-5 rounded-lg shadow-lg">
    <p class="text-2xl py-2">Your Query is Noted</p>
    <p class="text-lg">We will get back to you soon</p>
  </div>


  <div class="my-2 text-center  bg-white my-5 p-5 rounded-lg shadow-lg">
    <p class="text-lg font-bold text-center"> Reach Us at </p>
    <b> phone: <span class="text-gray-500">+91 8273363610</span> </b><br>
    <a [href]="'mailTo:mashhoorplus&#64;gmail.com'" class="underline"> Email :-
      mashhoorplus&#64;gmail.com</a>
    <p class="text-lg font-bold text-center">OPENING HOURS
      Monday to Saturday 10:00 AM – 6:00 PM
    </p>
    <div class="text-lg font-bold text-center my-5 text-gray-500">
      <p>Mashhoor Plus Pharmaceuticals</p>
      <p>227, Rajvansh Vihar Garh Road,</p>
      <p>Meerut, Uttar Pradesh, 250004</p>
    </div>

  </div>
</div>